import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AppFooterComponent } from './app-footer/app-footer.component'
import { AppLayoutComponent } from './app-layout.component'
import { AppLayoutService } from './services/app-layout.service'
import { RouterModule } from '@angular/router'
import { UnauthorizedHeaderComponent, UnauthorizedLayoutComponent } from './unauthorized-layout/unauthorized-layout.component'
import { AppBaseModule } from '../app-base.module'
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TranslationModule } from '../translation.module'


@NgModule({
  declarations: [
    AppFooterComponent,
    AppLayoutComponent,
    UnauthorizedLayoutComponent,
    UnauthorizedHeaderComponent,
    PrivacyPolicyComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    AppBaseModule,
    TranslationModule
  ],
  exports: [AppLayoutComponent, UnauthorizedHeaderComponent],
  providers: [AppLayoutService]
})
export class AppLayoutModule { }
